module.exports = __webpack_public_path__ + "static/media/cctvIcon_default.070fe3be.svg";